/* ==========================================================================
   Onyx Time — logika motywu
   Zastępuje reaktywny runtime z eksportu DesignCode (support.js) czystym JS.
   Bez zależności zewnętrznych.
   ========================================================================== */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ------------------------------------------------------- menu mobilne --- */
  function initNav() {
    $$('[data-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ----------------------------- pasek ogłoszeń: licznik oferty ----------- */
  /* Odliczamy do końca doby w Polsce (23:59:59 Europe/Warsaw) — niezależnie od
     tego, w jakiej strefie i z jak przestawionym zegarem siedzi klient. Czas
     warszawski czytamy z Intl przy każdym ticku, więc licznik się nie rozjeżdża
     i sam przechodzi przez zmiany czasu letniego. */
  var warsawClock = (function () {
    var fmt = null;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Warsaw',
        hour12: false,
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    } catch (e) {
      fmt = null;
    }

    return function () {
      var d = new Date();

      /* Zapas dla przeglądarek bez bazy stref czasowych: zegar urządzenia. */
      if (!fmt) return [d.getHours(), d.getMinutes(), d.getSeconds()];

      var h = 0, m = 0, s = 0;
      if (typeof fmt.formatToParts === 'function') {
        fmt.formatToParts(d).forEach(function (p) {
          if (p.type === 'hour') h = parseInt(p.value, 10);
          else if (p.type === 'minute') m = parseInt(p.value, 10);
          else if (p.type === 'second') s = parseInt(p.value, 10);
        });
      } else {
        var bits = String(fmt.format(d)).match(/(\d{1,2}):(\d{2}):(\d{2})/);
        if (!bits) return [d.getHours(), d.getMinutes(), d.getSeconds()];
        h = parseInt(bits[1], 10);
        m = parseInt(bits[2], 10);
        s = parseInt(bits[3], 10);
      }

      /* Część silników zwraca o północy 24 zamiast 0. */
      if (h === 24) h = 0;
      return [h, m, s];
    };
  })();

  function pad2(n) { return n < 10 ? '0' + n : String(n); }

  /* „2026-11-13 00:00” (czas polski) → znacznik czasu w ms. Przesunięcie
     Warszawy względem UTC bierzemy z Intl dla tej konkretnej chwili, więc
     data po zmianie czasu letniego też wychodzi dobrze. Zły format → NaN. */
  var warsawStamp = (function () {
    var fmt = null;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Warsaw',
        hourCycle: 'h23',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
      });
    } catch (e) {
      fmt = null;
    }

    function offsetAt(ms) {
      /* Zapas bez bazy stref: CET, czyli UTC+1. */
      if (!fmt || typeof fmt.formatToParts !== 'function') return 3600000;
      var p = {};
      fmt.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = parseInt(x.value, 10); });
      var asUtc = Date.UTC(p.year, p.month - 1, p.day, p.hour === 24 ? 0 : p.hour, p.minute, p.second);
      return asUtc - Math.floor(ms / 1000) * 1000;
    }

    return function (str) {
      var b = String(str).match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
      if (!b) return NaN;
      var wall = Date.UTC(+b[1], +b[2] - 1, +b[3], +(b[4] || 0), +(b[5] || 0), 0);
      var ms = wall - offsetAt(wall);
      /* Druga iteracja poprawia przypadek, gdy pierwsze przesunięcie trafiło
         po drugiej stronie zmiany czasu. */
      return wall - offsetAt(ms);
    };
  })();

  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var dEl = $('[data-cd-days]', el);
      var hEl = $('[data-cd-hours]', el);
      var mEl = $('[data-cd-minutes]', el);
      var sEl = $('[data-cd-seconds]', el);
      if (!hEl || !mEl || !sEl) return;

      /* init() rusza ponownie po shopify:section:load — bez tego każdy
         przeładowany pasek dokładałby kolejny, równoległy timer. */
      if (el.onyxTimer) clearTimeout(el.onyxTimer);

      /* Z datą końca odliczamy do niej (z dniami) i stajemy na zerach;
         bez niej, albo przy złym formacie — do końca doby w Polsce. */
      var end = el.hasAttribute('data-cd-end') ? warsawStamp(el.getAttribute('data-cd-end')) : NaN;

      var tick = function () {
        var left;
        if (!isNaN(end)) {
          left = Math.floor((end - Date.now()) / 1000);
        } else {
          var t = warsawClock();
          var elapsed = t[0] * 3600 + t[1] * 60 + t[2];
          /* 86399 zamiast 86400: o 00:00:00 licznik startuje od 23:59:59, a po
             dojściu do zera sam przeskakuje na nową dobę. */
          left = 86399 - elapsed;
        }
        if (left < 0) left = 0;

        if (dEl) dEl.textContent = pad2(Math.floor(left / 86400));
        /* Bez kafelka dni godziny zbierają całą resztę, żeby nic nie znikło. */
        hEl.textContent = pad2(Math.floor((dEl ? left % 86400 : left) / 3600));
        mEl.textContent = pad2(Math.floor((left % 3600) / 60));
        sEl.textContent = pad2(left % 60);

        /* Po końcu promocji nie ma już czego odliczać. */
        if (!isNaN(end) && left === 0) return;

        /* Dosuwamy kolejny tick do pełnej sekundy, żeby cyfry nie gubiły rytmu. */
        el.onyxTimer = setTimeout(tick, 1000 - (Date.now() % 1000));
      };

      tick();
    });
  }

  /* ------------------------------------------------------------ galeria --- */
  function initGallery(root) {
    var stage = $('[data-gallery-stage]', root);
    var shots = $$('[data-shot]', root);
    var thumbs = $$('[data-thumb]', root);
    var rail = $('[data-rail]', root);
    if (!stage || !shots.length) return null;

    var index = 0;

    function render() {
      shots.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        t.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (thumbs[index] && rail) {
        var t = thumbs[index];
        var left = t.offsetLeft - rail.clientWidth / 2 + t.clientWidth / 2;
        /* scrollTo nie istnieje w starszych przeglądarkach — wtedy zwykły skok. */
        if (typeof rail.scrollTo === 'function') {
          rail.scrollTo({ left: left, behavior: 'smooth' });
        } else {
          rail.scrollLeft = left;
        }
      }
      var lb = $('[data-lightbox-stage]', document);
      if (lb) {
        var active = shots[index];
        lb.innerHTML = active ? active.innerHTML : '';
        var navs = $$('[data-lightbox] .lightbox__nav');
        navs.forEach(function (n) { lb.appendChild(n); });
      }
    }

    function go(step) {
      index = (index + step + shots.length) % shots.length;
      render();
    }

    function set(n) { index = n; render(); }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (rail && rail.dataset.moved === '1') return;
        set(i);
      });
    });

    var prev = $('[data-gal-prev]', root);
    var next = $('[data-gal-next]', root);
    if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });

    /* przeciąganie po zdjęciu głównym = zmiana kadru */
    var x0 = null, swiped = false;
    stage.addEventListener('pointerdown', function (e) { x0 = e.clientX; swiped = false; });
    stage.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { swiped = true; go(dx < 0 ? 1 : -1); }
    });

    /* przeciąganie paska miniatur */
    if (rail) {
      var railX = null, railStart = 0;
      rail.addEventListener('pointerdown', function (e) {
        railX = e.clientX;
        railStart = rail.scrollLeft;
        rail.dataset.moved = '0';
        rail.classList.add('is-dragging');
      });
      rail.addEventListener('pointermove', function (e) {
        if (railX === null) return;
        var dx = e.clientX - railX;
        if (Math.abs(dx) > 4) rail.dataset.moved = '1';
        rail.scrollLeft = railStart - dx;
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (evt) {
        rail.addEventListener(evt, function () {
          if (railX === null) return;
          railX = null;
          rail.classList.remove('is-dragging');
          setTimeout(function () { rail.dataset.moved = '0'; }, 0);
        });
      });
    }

    /* lightbox */
    var lightbox = $('[data-lightbox]');
    if (lightbox) {
      var open = function () {
        if (swiped) { swiped = false; return; }
        render();
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      };
      var close = function () {
        lightbox.hidden = true;
        document.body.style.overflow = '';
      };
      stage.addEventListener('click', open);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.hasAttribute('data-lightbox-close')) close();
      });
      var lbPrev = $('[data-lightbox-prev]', lightbox);
      var lbNext = $('[data-lightbox-next]', lightbox);
      if (lbPrev) lbPrev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
      if (lbNext) lbNext.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
      document.addEventListener('keydown', function (e) {
        if (lightbox.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') go(-1);
        if (e.key === 'ArrowRight') go(1);
      });
    }

    /* Wstępne pobranie kadrów. Kadry 2+ mają loading="lazy" i siedzą w
       display:none, więc przeglądarka sięgała po plik dopiero po kliknięciu
       miniatury — stąd zwłoka i mignięcie pustej ramki. Przełączenie na
       „eager” pobiera ten sam rozmiar z srcset, który i tak zostałby wybrany,
       a decode() rozpakowuje obraz zawczasu, więc podmiana jest natychmiastowa.
       Pierwszy kadr (LCP) nie jest ruszany. */
    function warm(i) {
      var img = shots[i] && $('img', shots[i]);
      if (!img || img.getAttribute('data-warm')) return;
      img.setAttribute('data-warm', '1');
      img.loading = 'eager';
      if (typeof img.decode === 'function') img.decode().catch(function () {});
    }

    /* Najechanie albo dotknięcie miniatury pobiera jej kadr od razu,
       jeszcze zanim padnie kliknięcie. */
    thumbs.forEach(function (t, i) {
      ['pointerenter', 'touchstart', 'focus'].forEach(function (evt) {
        t.addEventListener(evt, function () { warm(i); }, { passive: true });
      });
    });

    /* Reszta kadrów dociąga się w tle, dopiero gdy strona skończy się
       ładować i przeglądarka ma wolną chwilę — bez konkurencji ze zdjęciem
       LCP i skryptami. */
    var warmAll = function () {
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
      idle(function () { for (var i = 1; i < shots.length; i++) warm(i); });
    };
    if (document.readyState === 'complete') warmAll();
    else window.addEventListener('load', warmAll, { once: true });

    render();
    return { set: set, go: go };
  }

  /* --------------------------------------------- warianty, pakiety, CTA --- */

  /* init() rusza ponownie po shopify:section:load (edytor motywu). Gdy sekcja
     nie została faktycznie podmieniona, ten sam element dostałby drugi
     nasłuch: checkbox przełączałby się dwa razy, a jedno kliknięcie w koszyk
     wysyłało dwa żądania. Znacznik na elemencie temu zapobiega. */
  function wireOnce(el, key) {
    if (!el) return false;
    var attr = 'data-onyx-' + key;
    if (el.getAttribute(attr) === '1') return false;
    el.setAttribute(attr, '1');
    return true;
  }

  /* Odczyt wyboru z DOM. Na poziomie modułu, bo korzysta z tego zarówno
     formularz (podgląd ceny), jak i wysyłka do koszyka. */
  function activePackIn(root) {
    var packs = $$('[data-pack]', root);
    return packs.filter(function (p) { return p.classList.contains('is-active'); })[0] || packs[0] || null;
  }
  /* Rzędy kolorów należą do konkretnego kafelka, więc czytamy tylko te
     z aktywnego pakietu — inaczej do koszyka trafiłby kolor z kafelka,
     którego klient nie wybrał. */
  function packRows(pack) {
    return pack ? $$('[data-color-row]', pack) : [];
  }
  function rowChoice(row) {
    var dots = $$('[data-swatch]', row);
    var picked = dots.filter(function (d) { return d.classList.contains('is-active'); })[0];
    return picked || dots[0] || null;
  }
  function chosenColors(pack) {
    return packRows(pack).map(rowChoice).filter(Boolean);
  }

  function initProductForm(root) {
    var form = $('[data-product-form]', root);
    if (!form) return;
    if (!wireOnce(form, 'form')) return;

    var idInput = $('[data-variant-id]', form);
    var qtyInput = $('[data-quantity]', form);
    var swatches = $$('[data-swatch]', root);
    /* Górny selektor jest nadrzędny: ustawia jeden kolor dla wszystkich
       sztuk w zaznaczonym zestawie. Ma własny atrybut, żeby logika rzędów
       w kafelkach go nie zagarnęła. */
    var topSwatches = $$('[data-top-swatch]', root);
    var colorHeadline = $('[data-color-headline]', root);
    var packs = $$('[data-pack]', root);
    /* Kazdy kafelek z bonusem ma wlasny przelacznik e-booka, wiec
       trzymamy je wszystkie i pytamy ten z aktywnego pakietu. */
    var ebookToggles = $$('[data-ebook-toggle]', root);
    function toggleOf(pack) { return pack ? $('[data-ebook-toggle]', pack) : null; }
    var ebookInput = $('[data-ebook-input]', root);
    /* Po jednym ukrytym polu na sztukę w pakiecie: slot 0 to pakiet
       jednosztukowy, sloty 1..N zapisują kolor każdej opaski osobno. */
    var colorInputs = $$('[data-color-input]', root);

    /* Kafelki pakietów niosą własne data-price / data-was, dlatego elementy
       ceny muszą być szukane wyłącznie wewnątrz .price-row — inaczej
       querySelector trafia w pierwszy kafelek. */
    var priceRow = $('.price-row', root);
    var priceEl = priceRow ? $('[data-price]', priceRow) : null;
    var wasEl = priceRow ? $('[data-price-was]', priceRow) : null;
    var saveEl = priceRow ? $('[data-price-save]', priceRow) : null;

    /* To samo dla przyklejonego paska: szukamy tylko w jego obrębie. */
    var stickyBar = $('[data-sticky-atc]');
    var stickyColor = stickyBar ? $('[data-sticky-color]', stickyBar) : null;
    var stickyQty = stickyBar ? $('[data-sticky-qty]', stickyBar) : null;
    var stickyPrice = stickyBar ? $('[data-sticky-price]', stickyBar) : null;
    var stickyWas = stickyBar ? $('[data-sticky-was]', stickyBar) : null;
    var stickySwatch = stickyBar ? $('[data-sticky-swatch]', stickyBar) : null;

    function activePack() { return activePackIn(root); }
    function rowOf(el) {
      var n = el;
      while (n && n !== root) {
        if (n.getAttribute && n.getAttribute('data-color-row') !== null) return n;
        n = n.parentNode;
      }
      return null;
    }

    /* Górny selektor pokazuje kolor pierwszej sztuki wybranego zestawu —
       dzięki temu nazwa obok etykiety zawsze zgadza się z tym, co w kafelku. */
    function syncTop(name) {
      if (colorHeadline && name) colorHeadline.textContent = name;
      topSwatches.forEach(function (t) {
        var on = t.getAttribute('data-color-name') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    function pickInRow(row, name) {
      var dots = $$('[data-swatch]', row);
      var target = dots.filter(function (d) {
        return d.getAttribute('data-color-name') === name;
      })[0];
      if (!target || target.classList.contains('is-soldout')) return;
      dots.forEach(function (d) {
        d.classList.remove('is-active');
        d.setAttribute('aria-checked', 'false');
      });
      target.classList.add('is-active');
      target.setAttribute('aria-checked', 'true');
    }

    function syncCart() {
      var pack = activePack();
      if (!pack) return;
      /* Przyklejony pasek pokazuje kolor pierwszej sztuki z wybranego pakietu. */
      var sw = chosenColors(pack)[0] || null;

      /* Jeśli pakiet ma własny wariant (np. zestaw 2 szt. jako osobny wariant),
         dodajemy ten wariant w ilości 1. W przeciwnym razie: wariant koloru
         w ilości odpowiadającej pakietowi. */
      var packVariant = pack.getAttribute('data-pack-variant');
      var colorVariant = sw ? sw.getAttribute('data-variant') : '';
      var qty = pack.getAttribute('data-qty') || '1';

      if (packVariant) {
        setBandField(form, idInput, packVariant);
        if (qtyInput) qtyInput.value = '1';
      } else {
        if (colorVariant) setBandField(form, idInput, colorVariant);
        if (qtyInput) qtyInput.value = qty;
      }

      /* Kolor każdej sztuki jako osobna właściwość pozycji — ale TYLKO wtedy,
         gdy nie niesie go wariant Shopify.

         Gdy kolory są wariantami, każda opaska jedzie własną linią koszyka
         z własnym wariantem i to on pokazuje kolor. Dokładanie do tego
         „Kolor #1 / Kolor #2” dawało efekt odwrotny do zamierzonego: wszystkie
         właściwości lądują na PIERWSZEJ pozycji, więc linia z opaską różową
         opisywała sama siebie także jako czarną. Właściwości zostają dla
         sklepów, w których kolor nie ma wariantu — tam nie ma innego nośnika. */
      var picks = chosenColors(pack);
      colorInputs.forEach(function (inp) {
        var slot = parseInt(inp.getAttribute('data-color-slot'), 10) || 0;
        var pick = null;
        if (slot === 0) {
          /* Slot 0 obsługuje wyłącznie pakiet jednosztukowy. */
          pick = picks.length === 1 ? picks[0] : null;
        } else if (picks.length > 1) {
          pick = picks[slot - 1] || null;
        }
        var value = pick ? (pick.getAttribute('data-color-name') || '') : '';
        var on = !!value && !pick.getAttribute('data-variant');
        inp.value = on ? value : '';
        inp.disabled = !on;
      });

      if (sw) syncTop(sw.getAttribute('data-color-name') || '');

      if (priceEl) priceEl.textContent = pack.getAttribute('data-price') || priceEl.textContent;
      if (wasEl) wasEl.textContent = pack.getAttribute('data-was') || '';
      if (saveEl) {
        var save = pack.getAttribute('data-save');
        saveEl.textContent = save || '';
        saveEl.hidden = !save;
      }
      if (stickyQty) stickyQty.textContent = pack.getAttribute('data-pack-label') || '';
      if (stickyPrice) stickyPrice.textContent = pack.getAttribute('data-price') || '';
      if (stickyWas) {
        stickyWas.textContent = pack.getAttribute('data-was') || '';
        stickyWas.hidden = !stickyWas.textContent;
      }
      if (sw) {
        if (stickyColor) stickyColor.textContent = sw.getAttribute('data-color-name') || '';
        if (stickySwatch) stickySwatch.style.borderColor = sw.getAttribute('data-color-hex') || '';
      }

      /* Tryb "forced" (e-book gratis) ma byc zawsze zaznaczony i nieklikalny —
         klient nie moze go odznaczyc, bo jest czescia pakietu. */
      var mode = pack.getAttribute('data-ebook') || 'none';
      var tgl = toggleOf(pack);
      if (tgl && mode === 'forced') {
        tgl.classList.remove('is-off');
        tgl.setAttribute('aria-disabled', 'true');
      } else if (tgl) {
        tgl.removeAttribute('aria-disabled');
      }

      /* e-book dostępny tylko przy pakietach z bonusem */
      if (ebookInput) {
        var hasBonus = pack.getAttribute('data-bonus') === 'true';
        /* W trybie „forced” e-book jest składnikiem zestawu i kafelek nie
           renderuje już checkboxa — nie ma więc czego pytać o stan. Brak
           przełącznika nie może znaczyć „odznaczony”. */
        var on = mode === 'forced' || !!(tgl && !tgl.classList.contains('is-off'));
        ebookInput.disabled = !(hasBonus && on);
      }
    }

    swatches.forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.classList.contains('is-soldout')) return;
        /* Wybór dotyczy tylko własnego rzędu — pozostałe sztuki w pakiecie
           zachowują swoje kolory. Kliknięcie propaguje do kafelka, więc
           zestaw sam staje się aktywny. */
        var scope = rowOf(s);
        var group = scope ? $$('[data-swatch]', scope) : swatches;
        group.forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        s.classList.add('is-active');
        s.setAttribute('aria-checked', 'true');
        syncCart();
      });
    });

    /* Kliknięcie w górze ustawia ten sam kolor we wszystkich rzędach
       zaznaczonego zestawu. Pojedynczy rząd można potem nadpisać. */
    topSwatches.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('is-soldout')) return;
        var name = t.getAttribute('data-color-name') || '';
        packRows(activePack()).forEach(function (row) { pickInRow(row, name); });
        syncCart();
      });
    });

    packs.forEach(function (p) {
      p.addEventListener('click', function () {
        packs.forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        p.classList.add('is-active');
        p.setAttribute('aria-checked', 'true');
        syncCart();
      });
    });

    ebookToggles.forEach(function (tgl) {
      tgl.addEventListener('click', function (e) {
        e.stopPropagation();
        if (tgl.getAttribute('aria-disabled') === 'true') return;
        tgl.classList.toggle('is-off');
        syncCart();
      });
    });

    /* przycisk w przyklejonym pasku wysyła ten sam formularz */
    $$('[data-sticky-submit]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });

    syncCart();
  }

  /* -------------------------------------------------- przyklejony pasek --- */
  function initStickyBar() {
    var bar = $('[data-sticky-atc]');
    var anchor = document.getElementById('cta-anchor');
    if (!bar || !anchor) return;
    document.body.classList.add('has-sticky-atc');

    var apply = function (visible) { bar.classList.toggle('is-visible', !visible); };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        apply(entries[0].isIntersecting);
      }, { threshold: 0 }).observe(anchor);
    } else {
      var measure = function () {
        var r = anchor.getBoundingClientRect();
        apply(r.bottom > 0 && r.top < (window.innerHeight || 0));
      };
      window.addEventListener('scroll', measure, { passive: true });
      window.addEventListener('resize', measure);
      measure();
    }
  }

  /* ------------------------------------------------- nieskończona taśma --- */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (track) {
      /* Taśma przewija się o -50%, więc treść musi być zduplikowana.
         Duplikat renderuje Liquid; tutaj tylko zabezpieczenie. */
      if (track.dataset.duplicated === '1') return;
      if (track.children.length && track.scrollWidth < window.innerWidth * 2) {
        track.innerHTML += track.innerHTML;
        track.dataset.duplicated = '1';
      }
    });
  }

  /* ------------------------------------------------------------- start --- */

  /* ------------------------------- wysuwany koszyk ------------------------ */
  /* Zmiany w koszyku idą przez Cart AJAX API, a widok odświeżamy przez
     Section Rendering API — dzięki temu ceny, sumy i progi liczy Liquid,
     a nie JavaScript, więc nie ma szansy na rozjazd z kasą. */

  var CART_SECTION = 'cart-drawer';

  function drawerEl() { return $('[data-cart-drawer]'); }

  function openCart() {
    var d = drawerEl();
    if (!d) return;
    d.hidden = false;
    /* reflow, żeby przejście CSS wystartowało od stanu zamkniętego */
    void d.offsetWidth;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    startReserve();
  }

  function closeCart() {
    var d = drawerEl();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (d && !d.classList.contains('is-open')) d.hidden = true;
    }, 280);
  }

  /* Podmienia zawartość szuflady świeżym HTML-em z serwera.

     UWAGA: ta funkcja NIE MOŻE niczego dodawać do koszyka. Wcześniej wołała
     automat dokładający e-book, a ten po dodaniu wywoływał refreshCart()
     ponownie — powstawała pętla bez hamulca: wystarczyło, że Liquid nie
     rozpoznał e-booka w koszyku (np. bez wskazanego produktu w ustawieniach),
     a jego pozycja liczyła się jako opaska, próg nigdy nie spadał i przy
     każdym odświeżeniu dochodziła kolejna sztuka. Dodawanie odbywa się teraz
     wyłącznie raz, przy kliknięciu „Dodaj do koszyka”. */
  /* Twardy limit obiegów sprzątania. Każdy obieg USUWA pozycję, więc ciąg
     i tak by się skończył — licznik jest bezpiecznikiem na wypadek, gdyby
     Liquid wskazał klucz, którego serwer nie potrafi skasować. */
  var GIFT_CLEANUP_MAX = 4;

  /* Wykonuje JEDNO zlecenie sprzątania wystawione przez szufladę
     (`data-gift-remove`). Wyłącznie usuwanie — nic tu nie ma prawa dodać
     pozycji do koszyka, bo to właśnie dodawanie przy odświeżaniu doprowadziło
     kiedyś do pętli dokładającej kolejne sztuki bez końca. */
  function runGiftCleanup(depth) {
    if (depth >= GIFT_CLEANUP_MAX) return Promise.resolve(null);
    var d = drawerEl();
    if (!d) return Promise.resolve(null);

    var node = $('[data-gift-remove]', d);
    var key = node ? node.getAttribute('data-gift-remove') : '';
    if (key) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function () { return refreshCart(false, depth + 1); })
        .catch(function () { /* przy błędzie sieci zostaje stary widok */ });
    }

    /* Zmiana progu e-booka po zmianie liczby opasek w samej szufladzie.
       Szuflada policzyła, który wariant się teraz należy; my wykonujemy
       jedną podmianę: stara pozycja znika, wskazana wchodzi na jej miejsce.

       To JEDYNE miejsce, w którym odświeżanie koszyka coś dodaje — i dlatego
       jest obwarowane trzema hamulcami. Po podmianie wariant zgadza się
       z oczekiwanym, więc kolejne renderowanie nie zleca już nic (1). Zlecenie
       dotyczy wyłącznie pozycji ze znacznikiem `_onyx`, czyli tej, którą motyw
       sam dołożył (2). A gdyby sklep z jakiegoś powodu nie przyjął podmiany,
       licznik obiegów i tak zatrzyma ciąg (3). Poprzednia wersja motywu nie
       miała żadnego z nich i dokładała e-booka bez końca. */
    var swap = $('[data-ebook-retier]', d);
    var oldKey = swap ? swap.getAttribute('data-ebook-retier') : '';
    var newId = swap ? variantIdFrom(swap.getAttribute('data-ebook-retier-variant')) : '';
    if (!oldKey || !newId) return Promise.resolve(null);

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: oldKey, quantity: 0 })
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(newId), quantity: 1, properties: { _onyx: 'ebook' } }]
          })
        });
      })
      .then(function () { return refreshCart(false, depth + 1); })
      .catch(function () { /* przy błędzie sieci zostaje stary widok */ });
  }

  function refreshCart(reopen, depth) {
    var round = depth || 0;
    /* Zawsze z korzenia sklepu, nie z bieżącego adresu. Na /products/… żądanie
       z Accept: application/json dostawało od Shopify JSON produktu zamiast
       sekcji, więc szuflada po dodaniu pokazywała „Koszyk (0)”. Szuflada nie
       zależy od strony, na której jest renderowana. */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=' + CART_SECTION, {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var markup = data[CART_SECTION];
        if (!markup) return;
        var parsed = new DOMParser().parseFromString(markup, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        var current = drawerEl();
        if (!fresh || !current) return;

        var wasOpen = current.classList.contains('is-open');
        current.innerHTML = fresh.innerHTML;
        if (wasOpen || reopen) {
          current.hidden = false;
          current.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        syncCartCount();
        startReserve();
        return runGiftCleanup(round);
      })
      .catch(function () { /* przy błędzie sieci zostaje stary widok */ });
  }

  /* Dokłada albo zdejmuje gratisowego e-booka. Decyzję podejmuje Liquid i
     podaje ją w data-gift-action, więc JS wykonuje najwyżej jedną operację;
     po odświeżeniu akcja jest już "none" i rekurencja się kończy. */
  function syncCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      })
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCart(); });
  }

  function addVariant(id, qty, props) {
    var item = { id: Number(id), quantity: qty || 1 };
    /* Znacznik roli wędruje z pozycją do koszyka. Dzięki niemu szuflada wie,
       którą linię dołożył motyw, nawet gdy w sklepie stoi kilka wariantów
       w tej samej cenie. */
    if (props) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refreshCart(true);
    });
  }

  /* Zdjęcie pozycji po KLUCZU linii, a nie po numerze porządkowym. Numer
     przesuwa się przy każdej zmianie zawartości koszyka, klucz nie. */
  function removeByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) {
      if (!r.ok) throw new Error('remove failed');
      return refreshCart();
    });
  }

  /* --- timer rezerwacji ---------------------------------------------------
     Odliczanie rusza w chwili, gdy w koszyku pojawia się produkt, a moment
     startu leży w localStorage — dzięki temu licznik biegnie dalej po
     przejściu na inną podstronę i po zamknięciu karty, zamiast zaczynać od
     nowa przy każdym otwarciu szuflady.

     Po dojściu do 00:00 koszyk jest czyszczony przez /cart/clear.js, a
     szuflada przeładowuje swój stan. */
  var RESERVE_KEY = 'onyxReserveStart';

  /* Uchwyt pętli musi żyć w module, a nie na elemencie paska. refreshCart()
     podmienia innerHTML szuflady, więc poprzedni <div data-reserve> wypada z
     drzewa razem z zapisanym na nim uchwytem: `clearTimeout` nie miał czego
     zatrzymać, stara pętla tykała dalej w oderwanym węźle, a każde odświeżenie
     koszyka dokładało kolejną. */
  var reserveTimer = 0;

  /* Zapas na wypadek, gdy przeglądarka blokuje localStorage (tryb prywatny,
     zablokowane dane witryn). Bez niego zapis cicho przepadał, odczyt zwracał
     pustkę i licznik startował od zera przy każdym renderze szuflady. */
  var reserveStarted = 0;

  /* Czyszczenie koszyka leci przez sieć, a wygaśnięcie może trafić w nas
     z kilku stron naraz: z pętli, z powrotu do karty i z odświeżenia
     szuflady. Bez tej blokady jedno 00:00 wysyłałoby kilka żądań pod rząd. */
  var reserveClearing = false;

  function reserveRead() {
    var saved = 0;
    try { saved = parseInt(localStorage.getItem(RESERVE_KEY), 10) || 0; } catch (e) { saved = 0; }
    return saved || reserveStarted;
  }

  function reserveWrite(value) {
    reserveStarted = value;
    try { localStorage.setItem(RESERVE_KEY, String(value)); } catch (e) {}
  }

  /* Kasujemy ślad po rezerwacji, gdy koszyk jest pusty albo właśnie wygasł.
     Dzięki temu NASTĘPNE dodanie produktu dostaje pełne okno od zera, a nie
     resztkę poprzedniego. */
  function reserveForget() {
    reserveStarted = 0;
    try { localStorage.removeItem(RESERVE_KEY); } catch (e) {}
  }

  /* Koniec rezerwacji: koszyk leci do zera, a widok szuflady przeładowuje się
     z serwera, więc pozycje, sumy i progi znikają razem z nim. */
  function reserveExpire() {
    if (reserveClearing) return;
    reserveClearing = true;
    reserveForget();
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    })
      .then(function () { return refreshCart(); })
      .catch(function () { /* przy błędzie sieci zostaje stary widok */ })
      .then(function () { reserveClearing = false; });
  }

  function startReserve() {
    if (reserveTimer) { clearTimeout(reserveTimer); reserveTimer = 0; }

    /* Pasek renderuje się tylko przy niepustym koszyku, więc jego brak znaczy
       „nie ma czego rezerwować”. Zerujemy wtedy zapisany start — inaczej
       koszyk opróżniony ręcznie zostawiłby tykające okno, które ucięłoby
       czas następnemu zamówieniu. */
    var box = $('[data-reserve]');
    if (!box || !$('[data-reserve-clock]', box)) { reserveForget(); return; }

    var minutes = parseInt(box.getAttribute('data-reserve-minutes'), 10) || 10;
    var total = minutes * 60 * 1000;

    var tick = function () {
      /* Kasujemy zaplanowane tyknięcie na wejściu, więc tę funkcję można wołać
         z zewnątrz (powrót do karty) bez ryzyka rozmnożenia pętli. */
      if (reserveTimer) { clearTimeout(reserveTimer); reserveTimer = 0; }

      /* Zegar czytamy z dokumentu przy każdym tyknięciu — po odświeżeniu
         szuflady element z domknięcia jest już oderwany od strony i wpisy
         trafiałyby w próżnię. */
      var clock = $('[data-reserve-clock]');
      if (!clock) return;

      var now = Date.now();
      var started = reserveRead();

      /* Pierwsze tyknięcie po dodaniu produktu ustawia moment startu. Ten sam
         warunek łapie start w przyszłości, czyli cofnięty zegar systemowy. */
      if (!started || started > now) {
        started = now;
        reserveWrite(started);
      }

      var passed = now - started;
      var left = Math.ceil((total - passed) / 1000);
      if (left < 0) left = 0;
      var m = Math.floor(left / 60);
      var s = left % 60;
      clock.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);

      /* 00:00 pokazujemy PRZED czyszczeniem — klient widzi, dlaczego koszyk
         za chwilę opustoszał, zamiast dostać samą pustą szufladę. */
      if (passed >= total) { reserveExpire(); return; }

      /* Kolejne tyknięcie mierzymy od momentu startu, a nie od pełnej sekundy
         zegara systemowego — inaczej przy dłużej otwartej karcie sekundy
         potrafiły się dublować albo przeskakiwać. */
      reserveTimer = setTimeout(tick, 1000 - (passed % 1000));
    };

    tick();
  }

  function initCartDrawer() {
    /* Nasłuchy wiszą na dokumencie, a init() rusza ponownie po
       shopify:section:load. Bez tej blokady każda przeładowana sekcja
       dokładała drugi komplet obsługi — jedno kliknięcie „+” zmieniało
       wtedy ilość dwa razy, a przycisk upsellu dodawał e-booka podwójnie. */
    startReserve();
    if (!wireOnce(document.documentElement, 'drawer')) return;

    /* Karta w tle dostaje mocno spowolnione setTimeout — po powrocie zegar
       pokazywałby wartość sprzed kilku minut. Odświeżamy go od razu; tick()
       kasuje zaplanowane tyknięcie na wejściu, więc pętla się nie dubluje. */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) startReserve();
    });

    /* Ikona koszyka w nagłówku otwiera szufladę zamiast przeładowywać stronę. */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest ? e.target.closest('[data-cart-open]') : null;
      if (opener && drawerEl()) {
        e.preventDefault();
        refreshCart(true);
        openCart();
        return;
      }

      var closer = e.target.closest ? e.target.closest('[data-cart-close]') : null;
      if (closer) { e.preventDefault(); closeCart(); return; }

      var up = e.target.closest ? e.target.closest('[data-qty-up]') : null;
      var down = e.target.closest ? e.target.closest('[data-qty-down]') : null;
      var rm = e.target.closest ? e.target.closest('[data-remove]') : null;
      var add = e.target.closest ? e.target.closest('[data-upsell-add]') : null;

      if (up || down || rm) {
        var btn = up || down || rm;
        var line = parseInt(btn.getAttribute('data-line-index'), 10);
        if (!line) return;
        var row = btn.closest('.cline');
        var nEl = row ? $('.qty__n', row) : null;
        var current = nEl ? parseInt(nEl.textContent, 10) || 1 : 1;
        var next = rm ? 0 : (up ? current + 1 : current - 1);
        if (next < 0) next = 0;
        btn.disabled = true;
        changeLine(line, next);
      }

      if (add) {
        var vid = add.getAttribute('data-variant-id');
        if (!vid) return;
        add.disabled = true;
        addVariant(vid, 1).catch(function () { add.disabled = false; });
      }

      /* Ochrona przesyłki. Stanu NIE trzymamy w przycisku — po każdej zmianie
         szuflada renderuje się od nowa i Liquid ustawia go z zawartości
         koszyka. Obecny klucz linii znaczy „już w koszyku”, czyli kliknięcie
         ma ją zdjąć; jego brak znaczy „dołóż”. */
      var care = e.target.closest ? e.target.closest('[data-care-toggle]') : null;
      if (care) {
        e.preventDefault();
        if (care.disabled) return;
        var careKey = care.getAttribute('data-care-key');
        var careVariant = variantIdFrom(care.getAttribute('data-care-variant'));
        if (!careKey && !careVariant) return;

        care.disabled = true;
        var praca = careKey
          ? removeByKey(careKey)
          : addVariant(careVariant, 1, { _onyx: 'care' });
        praca.catch(function () { care.disabled = false; });
      }
    });

    document.addEventListener('keydown', function (e) {
      var d = drawerEl();
      if (e.key === 'Escape' && d && d.classList.contains('is-open')) closeCart();
    });
  }

  /* Dodanie z karty produktu otwiera szufladę zamiast przeładowania strony. */
  /* ---------------------------------------- e-book jako osobna pozycja ---
     E-book to samodzielny produkt cyfrowy w Shopify, więc musi trafić do
     koszyka jako własny line item — inaczej aplikacja dostarczająca plik
     nie ma czego obsłużyć.

     ID WARIANTÓW USTALA LIQUID, nie ten plik. Snippet `onyx-addons.liquid`
     znajduje e-booka i darmową wysyłkę sam — po wskazaniu w ustawieniach,
     po uchwycie produktu albo po tytule — i wstawia gotowe numery
     w atrybuty formularza (`data-ebook-variant` itd.). Skrypt czyta stamtąd,
     więc motyw działa bez wpisywania czegokolwiek w tym pliku.

     Stałe poniżej to ostatnia deska ratunku: użyj ich tylko wtedy, gdy
     produkt ma nietypowy tytuł i uchwyt, przez co automat go nie znajduje.
     Wklej same cyfry, np. '45678901234567' (Shopify: Products → produkt →
     wariant → ostatni fragment adresu w przeglądarce). */
  var EBOOK_VARIANT_ID = 'TUTAJ_ID_EBOOKA';
  var ebookWarned = false;

  var SHIPPING_VARIANT_ID = 'TUTAJ_ID_WYSYLKI';

  /* Akceptujemy wyłącznie sam numer wariantu. Wcześniejsza wersja usuwała
     znaki niebędące cyfrą, przez co z placeholdera „TUTAJ_ID_WYSYLKI”
     robił się nieistniejący identyfikator i leciał do koszyka. */
  function variantIdFrom(value) {
    var raw = String(value == null ? '' : value).trim();
    return /^\d+$/.test(raw) ? raw : '';
  }

  /* Zestaw z gratisowym e-bookiem dostaje wariant 0 zł, pozostałe — płatny.
     Bez skonfigurowanego wariantu gratisowego oba wskazują to samo i cenę
     zbija rabat automatyczny. */
  function ebookVariantOf(form, pack) {
    /* Zestaw wskazuje PRÓG ceny e-booka, a nie tylko „gratis albo nie”:
       pakiet 1 kupuje wariant katalogowy, pakiet 2 promocyjny, pakiet 3
       ten za 0 zł. Gdy któregoś wariantu nie ma w sklepie, snippet Liquida
       zsyła próg do najbliższego istniejącego — motyw doda wtedy e-booka
       w cenie, która NAPRAWDĘ obowiązuje, zamiast pokazywać rabat,
       którego kasa nie zna. */
    var tier = pack ? (pack.getAttribute('data-ebook-tier') || '') : '';
    if (!tier) {
      /* Starsze kafelki znają tylko flagę „gratis”. */
      tier = (!!pack && pack.getAttribute('data-ebook-free') === 'true') ? 'gift' : 'paid';
    }

    var id = '';
    if (tier === 'gift') id = variantIdFrom(form.getAttribute('data-ebook-variant-gift'));
    if (!id && tier === 'mid') id = variantIdFrom(form.getAttribute('data-ebook-variant-mid'));
    if (!id) id = variantIdFrom(form.getAttribute('data-ebook-variant'));
    if (!id) id = variantIdFrom(EBOOK_VARIANT_ID);
    /* Bez wariantu e-book NIE MOŻE powstać jako osobna pozycja koszyka —
       zostaje wtedy tylko właściwość „E-book” doklejona do opaski, czyli
       dokładnie to, czego makieta nie przewiduje. To nie jest usterka kodu,
       lecz brak konfiguracji, więc mówimy o tym wprost i raz. */
    if (!id && !ebookWarned) {
      ebookWarned = true;
      if (window.console && console.error) {
        console.error('[onyx] e-book NIE zostanie dodany jako osobna pozycja koszyka: ' +
          'brak wariantu. Uzupelnij w edytorze motywu, sekcja „Karta produktu”: ' +
          '„E-book – produkt” oraz „E-book – nazwa wariantu gratisowego” (wariant 0 zl). ' +
          'Do czasu uzupelnienia e-book pozostanie jedynie wlasciwoscia pozycji z opaska.');
      }
    }
    return id;
  }

  function shipVariantOf(form) {
    return variantIdFrom(form.getAttribute('data-ship-variant')) || variantIdFrom(SHIPPING_VARIANT_ID);
  }

  /* none = nie dodawaj, optional = decyduje checkbox, forced = zawsze. */
  function ebookNeeded(pack, toggle) {
    var mode = pack ? pack.getAttribute('data-ebook') : 'none';
    if (mode === 'forced') return true;
    if (mode === 'optional') return !!toggle && !toggle.classList.contains('is-off');
    return false;
  }

  /* Po jednej pozycji na każdą wybraną opaskę, żeby zamówienie niosło
     dokładnie te kolory, które wskazał klient. Ten sam wariant powtórzony
     w kilku rzędach scalamy w jedną pozycję o większej ilości.
     Zwraca null, gdy któryś kolor nie ma wariantu — wtedy wysyłkę
     przejmuje zwykły formularz (kolor jako właściwość pozycji). */
  /* Właściwości pozycji (Kolor #1, Kolor #2, E-book) opisują OPASKĘ i tylko
     ona ma je nieść. Czytamy je z włączonych pól ukrytych formularza —
     wcześniej jechały wyłącznie zapasowym submitem, więc przy normalnym
     dodaniu ginęły, a w razie awarii doklejały się do jedynego pola „id”. */
  function bandProperties(form, skipEbookMarker) {
    var props = null;
    $$('input[name]', form).forEach(function (inp) {
      if (inp.disabled) return;
      /* Gdy e-book wchodzi do koszyka jako własna pozycja, znacznik „E-book”
         na opasce tylko dublowałby tę samą informację w zamówieniu. */
      if (skipEbookMarker && inp.hasAttribute('data-ebook-input')) return;
      var name = inp.getAttribute('name') || '';
      if (name.indexOf('properties[') !== 0) return;
      var key = name.slice(11, name.length - 1);
      var val = (inp.value || '').replace(/^\s+|\s+$/g, '');
      if (!key || !val) return;
      if (!props) props = {};
      props[key] = val;
    });
    return props;
  }

  /* Zwraca pozycje SAMEJ opaski. Dodatki dokładane są osobno, już po tej
     liście, żeby żaden z nich nie mógł zająć miejsca produktu głównego. */
  function buildBandItems(root, form, skipEbookMarker) {
    var pack = activePackIn(root);
    if (!pack) return null;

    var props = form ? bandProperties(form, skipEbookMarker) : null;
    var items = [];

    var packVariant = pack.getAttribute('data-pack-variant');
    if (packVariant) {
      items.push({ id: packVariant, quantity: 1 });
    } else {
      var picks = chosenColors(pack);
      if (!picks.length) return null;
      var complete = true;
      picks.forEach(function (dot) {
        var id = dot.getAttribute('data-variant');
        if (!id) { complete = false; return; }
        var same = items.filter(function (it) { return it.id === id; })[0];
        if (same) same.quantity += 1;
        else items.push({ id: id, quantity: 1 });
      });
      if (!complete || !items.length) return null;
    }

    /* Cały opis wyboru trafia na pierwszą pozycję opaski — powtarzanie go
       na każdej linii tylko zaśmiecałoby zamówienie. */
    if (props) items[0].properties = props;
    return items;
  }

  function cartState() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  /* Wszystkie warianty przypisane do danej roli technicznej. E-book ma dwa:
     płatny (upsell przy jednej opasce) i gratisowy (zestawy 2 i 3). */
  function roleVariants(form, role) {
    return (role === 'ebook'
      ? ['data-ebook-variant', 'data-ebook-variant-gift', 'data-ebook-variant-mid']
      : ['data-ship-variant'])
      .map(function (attr) { return variantIdFrom(form.getAttribute(attr)); })
      .filter(function (id) { return !!id; });
  }

  /* WSZYSTKIE pozycje koszyka pełniące daną rolę — nie tylko te o jednym
     konkretnym numerze wariantu.

     To rozróżnienie jest tu sednem sprawy. Shopify traktuje jako osobne
     linie koszyka te same warianty różniące się właściwościami, więc darmowa
     wysyłka dodana starszą wersją motywu (bez znacznika, czasem z doklejonym
     kolorem) i ta dodana teraz (ze znacznikiem `_onyx`) to dla koszyka DWIE
     niezależne pozycje. Sprawdzanie po samym numerze wariantu ich nie widziało
     i pozycja „Darmowa Wysyłka” potrafiła stanąć w koszyku dwa razy. */
  function roleLines(cart, form, role) {
    if (!cart || !cart.items) return [];
    var ids = roleVariants(form, role);
    return cart.items.filter(function (it) {
      var marked = it.properties && it.properties._onyx;
      /* Znacznik jest rozstrzygający; numer wariantu obsługuje pozycje
         dodane, zanim znaczniki w ogóle istniały. */
      if (marked) return marked === role;
      return ids.indexOf(String(it.variant_id)) >= 0;
    });
  }

  /* Każda rola techniczna ma być w koszyku DOKŁADNIE RAZ, w jednej sztuce.

     Jeden przebieg sprząta wszystkie źródła nadmiaru naraz: podwójne
     kliknięcie, powrót na stronę, przeskok między pakietami (płatny e-book
     obok gratisowego) i pozostałości po starszej wersji motywu. Zostaje
     pozycja, której oczekuje wybrany zestaw (`preferred`), reszta znika.

     Operacje idą po kolei, nie równolegle: każda zmiana koszyka przelicza
     jego zawartość, więc równoległe żądania celowałyby w nieaktualny stan. */
  function enforceSingleTechnical(form, preferred) {
    return cartState().then(function (cart) {
      var ops = [];

      ['ebook', 'ship'].forEach(function (role) {
        var want = preferred && preferred[role] ? String(preferred[role]) : '';
        var lines = roleLines(cart, form, role);
        if (!lines.length) return;

        /* Która pozycja ma przeżyć. Wyżej stoi ta z poprawnym znacznikiem
           (czyli dodana przez aktualny motyw, bez doklejonych właściwości
           opaski), a przy remisie ta, której oczekuje wybrany zestaw:
           pakiet 1 kupuje e-booka płatnego, pakiety 2 i 3 dostają gratisowy. */
        var score = function (line) {
          var marked = line.properties && line.properties._onyx === role ? 2 : 0;
          var wanted = want && String(line.variant_id) === want ? 1 : 0;
          return marked + wanted;
        };
        lines.sort(function (a, b) { return score(b) - score(a); });

        /* Darmowa wysyłka nie jest już pozycją koszyka — dostawa jest darmowa
           w samych stawkach Shopify. Gdy żaden zestaw jej nie zamawia, znika
           także pozostałość po wcześniejszej wizycie, zamiast zostać w jednej
           sztuce. */
        var dropAll = role === 'ship' && !want;

        lines.forEach(function (line, i) {
          if (i > 0 || dropAll) ops.push({ id: line.key, quantity: 0 });
          else if (line.quantity > 1) ops.push({ id: line.key, quantity: 1 });
        });
      });

      if (!ops.length) return null;
      return ops.reduce(function (chain, op) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(op)
          });
        });
      }, Promise.resolve());
    });
  }

  /* Warianty opaski wypisane przez Liquid. Dzięki nim skrypt nie musi ufać
     temu, co akurat siedzi w ukrytym polu „id” — może sprawdzić, że pozycja
     główna to naprawdę opaska. */
  function bandVariantSet(form) {
    var raw = form.getAttribute('data-band-variants') || '';
    var set = {};
    raw.split(',').forEach(function (part) {
      var id = variantIdFrom(part);
      if (id) set[id] = true;
    });
    return set;
  }

  /* Warianty dodatków: e-book (płatny i gratisowy) oraz darmowa wysyłka. */
  function technicalVariantSet(form) {
    var set = {};
    ['data-ebook-variant', 'data-ebook-variant-gift', 'data-ebook-variant-mid', 'data-ship-variant'].forEach(function (attr) {
      var id = variantIdFrom(form.getAttribute(attr));
      if (id) set[id] = true;
    });
    return set;
  }

  /* Ukryte pole „id” opisuje OPASKĘ i nic innego. Darmowa wysyłka ani e-book
     nie mają prawa w nim stanąć — inaczej klient kupowałby pozycję za 0 zł
     zamiast produktu. Jedyny wyjątek: gdy wskazany dodatek okazuje się
     wariantem samej opaski, wygrywa przynależność do produktu głównego,
     bo to zwykła pomyłka w konfiguracji dodatku. */
  function setBandField(form, input, candidate) {
    if (!input) return false;
    var id = variantIdFrom(candidate);
    if (!id) return false;
    if (technicalVariantSet(form)[id] && !bandVariantSet(form)[id]) {
      if (window.console && console.warn) {
        console.warn('[onyx] pominieto podmiane pola "id" na wariant techniczny ' + id +
          ' — pole produktu glownego zostaje bez zmian');
      }
      return false;
    }
    input.value = id;
    return true;
  }

  /* Blokada wielokrotnego kliknięcia. Na poziomie modułu, bo obsługa jest
     jedna dla całego dokumentu — kolejne zgłoszenia w trakcie trwającego
     żądania są ignorowane, nie kolejkowane. */
  var addBusy = false;

  /* Przechwytywanie jest DELEGOWANE na dokument i działa w fazie
     przechwytywania, zanim zdarzenie dojdzie do formularza.

     Wcześniej listener wisiał na konkretnym formularzu i dokładała go
     inicjalizacja karty produktu. Wystarczyło, że formularz powstał po
     starcie skryptu (edytor motywu, sekcja doładowana asynchronicznie) albo
     że inicjalizacja poleciała wyjątkiem przed dojściem do tego miejsca —
     i „Dodaj do koszyka” wracał do natywnego POST na /cart, czyli
     przeładowania strony i wyrzucenia klienta z karty produktu.

     Teraz przechwytujemy KAŻDY submit `[data-product-form]`, niezależnie od
     tego, kiedy formularz powstał i czy cokolwiek zdążyło go „podpiąć”. */
  function initAjaxAdd() {
    if (!wireOnce(document.documentElement, 'add')) return;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      var isProductForm = form && form.getAttribute &&
        form.getAttribute('data-product-form') !== null;
      if (!isProductForm) return;
      e.preventDefault();
      handleAdd(form);
    }, true);
  }

  function handleAdd(form) {
    var root = (form.closest && form.closest('[data-product-root]')) || document;

    function buttons() {
      return $$('button[type="submit"]', form).concat($$('[data-sticky-submit]'));
    }
    function lock(on) {
      addBusy = on;
      buttons().forEach(function (b) { b.disabled = on; });
    }

    if (addBusy) return;

    var pack = activePackIn(root);
    /* Przelacznik z aktywnego kafelka, nie pierwszy z brzegu. */
    var toggle = pack ? $('[data-ebook-toggle]', pack) : null;
    var ebookId = ebookNeeded(pack, toggle) ? ebookVariantOf(form, pack) : '';
    /* Darmowa wysylka jako osobna pozycja — przy zestawach oznaczonych
       data-ship="forced". Tak jak e-book: tylko raz w koszyku. */
    var shipId = (pack && pack.getAttribute('data-ship') === 'forced') ? shipVariantOf(form) : '';

    /* Dodatki ustalamy PRZED zbudowaniem listy, bo od nich zależy, czy
       znacznik „E-book” ma jeszcze sens jako właściwość opaski. */
    var items = buildBandItems(root, form, !!ebookId);

    /* Ile sztuk niesie WYBRANY zestaw. Ta liczba musi obowiązywać także
       w ścieżkach zapasowych poniżej — wcześniej była tam zaszyta jedynka,
       więc gdy któryś kolor stracił powiązanie z wariantem Shopify (zmieniona
       nazwa opcji, usunięty wariant, nowy kafelek koloru bez `option_value`),
       klient wybierał „3 opaski”, a do koszyka trafiała JEDNA. Ścieżka główna
       liczyła sztuki poprawnie, więc błąd ujawniał się tylko przy takiej
       rozbieżności w katalogu — i był po cichu zaniżonym zamówieniem. */
    var packQty = parseInt(pack && pack.getAttribute('data-qty'), 10) || 1;

    /* Zapas bez przeładowania strony: dodajemy domyślny wariant opaski
       przez AJAX. Wcześniej szedł tu natywny submit(), który wysyłał
       formularz na /cart i przenosił klienta na osobną podstronę. */
    if (!items || !items.length) {
      var fallbackId = variantIdFrom(form.getAttribute('data-band-default'));
      var idField = $('[data-variant-id]', form);
      if (!fallbackId && idField) fallbackId = variantIdFrom(idField.value);
      if (!fallbackId) return;
      items = [{ id: fallbackId, quantity: packQty }];
    }

    /* Warianty techniczne (e-book, darmowa wysyłka) nie mogą być produktem
       głównym w ŻADNYM przypadku — nawet gdyby sekcja przez pomyłkę
       renderowała taki produkt. Lepiej nie dodać nic, niż sprzedać
       klientowi pozycję za 0 zł zamiast opaski. */
    var technical = technicalVariantSet(form);

    /* Pozycja główna MUSI być wariantem opaski. Gdyby cokolwiek innego
       trafiło na jej miejsce, wracamy do wariantu domyślnego z Liquida. */
    var bandSet = bandVariantSet(form);
    var known = false;
    var allTechnical = true;
    for (var k in bandSet) {
      known = true;
      if (!technical[k]) allTechnical = false;
    }

    if (known) {
      items = items.filter(function (it) { return bandSet[String(it.id)]; });
      /* Gdy CAŁY produkt sekcji jest techniczny, nie ma czego sprzedać —
         blokujemy. Gdy technicznym id okazał się pojedynczy wariant opaski,
         to zwykła pomyłka w konfiguracji dodatku: przynależność do produktu
         głównego wygrywa, a dodatek zostanie pominięty niżej. */
      if (allTechnical) items = [];
    } else {
      items = items.filter(function (it) { return !technical[String(it.id)]; });
    }

    if (!items.length) {
      var safeId = variantIdFrom(form.getAttribute('data-band-default'));
      if (!safeId || technical[safeId]) {
        if (window.console && console.error) {
          console.error('[onyx] przerwano dodawanie: sekcja produktu nie wskazuje opaski, ' +
            'tylko produkt techniczny. Ustaw „Produkt” w edytorze motywu.');
        }
        return;
      }
      /* Ta sama zasada co wyżej: ilość bierze się z wybranego zestawu. */
      items = [{ id: safeId, quantity: packQty }];
    }

    lock(true);

    /* Zabezpieczenie przed pomyłką w konfiguracji: gdyby w polu e-booka lub
       wysyłki wylądował wariant samej opaski, dodatek podbiłby ilość produktu
       głównego zamiast powstać jako osobna pozycja. W takiej sytuacji
       pomijamy go zamiast psuć zamówienie. */
    var bandIds = items.map(function (it) { return String(it.id); });
    var collides = function (id) {
      return bandIds.indexOf(String(id)) >= 0 || (known && bandSet[String(id)]);
    };
    if (ebookId && collides(ebookId)) ebookId = '';
    if (shipId && collides(shipId)) shipId = '';

    var prepared = (ebookId || shipId)
      ? cartState().then(function (cart) {
          /* Dodatki DOPISUJEMY na koniec listy — opis wyboru (kolory)
             należy do opaski, nie do e-booka ani do wysyłki.

             Jedyna właściwość, jaką dostają, to techniczny znacznik roli.
             Nazwa zaczyna się od podkreślenia, więc Shopify ukrywa ją
             w koszyku i w zamówieniu, a szuflada rozpoznaje po niej gratis
             nawet wtedy, gdy w jej ustawieniach nie wpisano ID wariantu.
             Wcześniej rozpoznanie opierało się wyłącznie na ID przepisanym
             ręcznie w DWÓCH miejscach (sekcja produktu i sekcja koszyka)
             i przy najmniejszej rozbieżności darmowa wysyłka liczyła się
             jako opaska: próg gratisów przestawał się zgadzać, a pozycja
             szła na listę jako zwykły, płatny produkt.

             Dodatek dokładamy tylko wtedy, gdy w koszyku NIE MA jeszcze tej
             samej pozycji z tym samym znacznikiem. Pozycje bez znacznika
             (starsze, czasem z doklejonym kolorem opaski) celowo nie blokują
             dodania — powstaje wtedy czysta pozycja, a starą zdejmie
             `enforceSingleTechnical`, które przedkłada oznaczoną nad zastaną.

             `pushed` pilnuje jeszcze jednego: gdyby e-book i wysyłka wskazywały
             omyłkowo TEN SAM wariant, obie role wpadłyby do jednego żądania
             i Shopify zrobiłby z nich dwie osobne linie (różnią się
             właściwością), bo migawka koszyka pobrana przed dodaniem żadnej
             z nich jeszcze nie widzi. To była druga „Darmowa Wysyłka”. */
          var pushed = {};
          var addRole = function (id, role) {
            if (!id || pushed[id]) return;
            var already = roleLines(cart, form, role).filter(function (it) {
              return String(it.variant_id) === String(id) &&
                it.properties && it.properties._onyx === role;
            })[0];
            if (already) return;
            pushed[id] = true;
            items.push({ id: id, quantity: 1, properties: { _onyx: role } });
          };

          if (ebookId && shipId && String(ebookId) === String(shipId) &&
              window.console && console.error) {
            console.error('[onyx] e-book i darmowa wysylka wskazuja TEN SAM wariant (' + ebookId +
              '). Sprawdz w edytorze motywu pola „E-book – produkt” i „Darmowa wysylka – produkt” ' +
              'w sekcji „Karta produktu” — dodana zostanie tylko jedna pozycja.');
          }

          addRole(ebookId, 'ebook');
          addRole(shipId, 'ship');
        })
      : Promise.resolve();

    prepared
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      /* Uruchamiamy ZAWSZE, także gdy ten zestaw nie dokłada żadnego gratisu.
         Dzięki temu jedno kliknięcie „Dodaj do koszyka” naprawia też koszyk
         zaśmiecony wcześniej — np. dwiema pozycjami darmowej wysyłki. */
      .then(function () {
        return enforceSingleTechnical(form, { ebook: ebookId, ship: shipId });
      })
      .then(function () {
        /* Zdarzenie dla ewentualnych integracji; obsluga to samo odswiezenie,
           wiec nie da sie nim niczego dodac ani zapetlic. */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return refreshCart(true);
      })
      .then(function () { lock(false); })
      .catch(function () {
        /* Nawet przy błędzie sieci zostajemy na karcie produktu — przerzucenie
           klienta na /cart było gorsze niż komunikat i możliwość ponowienia. */
        lock(false);
        if (window.console && console.warn) {
          console.warn('[onyx] nie udalo sie dodac do koszyka — sprobuj ponownie');
        }
      });
  }
  /* Każdy moduł uruchamiany osobno. Awaria jednego (np. galerii) nie może
     zablokować pozostałych — wcześniej wyjątek w galerii przerywał całą
     inicjalizację, przez co przestawał działać wybór pakietu i koszyk. */
  function safely(name, fn, arg) {
    try {
      fn(arg);
    } catch (e) {
      if (window.console && console.error) {
        console.error('[onyx] blad inicjalizacji: ' + name, e);
      }
    }
  }

  /* --- rolki UGC ----------------------------------------------------------
     Kafelek ma dwa stany i tylko pierwszy należy do motywu.

     PRZED startem: brak `controls`, widać klatkę podglądu i krążek na środku.
     PO starcie: dokładamy `controls` i oddajemy kafelek przeglądarce —
     pasek postępu, menu trzech kropek (pełny ekran, pobieranie, wyciszenie,
     prędkość odtwarzania, obraz w obrazie) i skróty klawiszowe są jej własne.

     Dlatego skrypt NIE nasłuchuje kliknięć na samym wideo. Gdyby to robił,
     przechwytywałby trafienia w pasek i w trzy kropki, a menu nigdy by się
     nie otworzyło. Cała obsługa wisi na przycisku startu, który po pierwszym
     kliknięciu znika z kafelka. */
  function initUgcVideo() {
    if (!wireOnce(document.documentElement, 'ugc')) return;

    function start(przycisk) {
      var kafelek = przycisk.closest ? przycisk.closest('[data-ugc-tile]') : null;
      if (!kafelek) return;
      var film = $('video', kafelek);
      if (!film) return;

      kafelek.classList.add('is-playing');
      film.controls = true;

      /* Odtwarzanie rusza z gestu użytkownika, więc przeglądarka pozwala
         puścić materiał z dźwiękiem. Gdyby jednak odmówiła, sterowanie i tak
         jest już widoczne — kupujący wciśnie play sam. */
      var proba = film.play();
      if (proba && proba.catch) proba.catch(function () {});
    }

    document.addEventListener('click', function (e) {
      var przycisk = e.target.closest ? e.target.closest('[data-ugc-start]') : null;
      if (!przycisk) return;
      e.preventDefault();
      start(przycisk);
    });

    /* Jedna rolka naraz. Bez tego dwa filmy potrafiły grać równocześnie —
       wystarczyło puścić drugi, nie zatrzymawszy pierwszego.
       Nasłuch na fazie przechwytywania, bo zdarzenia mediów nie bąbelkują. */
    document.addEventListener('play', function (e) {
      var film = e.target;
      if (!film || film.tagName !== 'VIDEO') return;
      var kafelek = film.closest ? film.closest('[data-ugc-tile]') : null;
      if (!kafelek) return;
      kafelek.classList.add('is-playing');
      $$('[data-ugc-tile] video').forEach(function (inny) {
        if (inny !== film && !inny.paused) inny.pause();
      });
    }, true);
  }

  function init() {
    safely('nav', initNav);
    safely('countdown', initCountdown);
    safely('stickyBar', initStickyBar);
    safely('marquee', initMarquee);
    safely('cartDrawer', initCartDrawer);
    safely('ugcVideo', initUgcVideo);
    safely('ajaxAdd', initAjaxAdd);
    $$('[data-product-root]').forEach(function (root) {
      safely('gallery', initGallery, root);
      safely('productForm', initProductForm, root);
    });
  }

  /* Przechwytywanie „Dodaj do koszyka” podpinamy NATYCHMIAST, jeszcze przed
     DOMContentLoaded — reszta modułów może spokojnie zaczekać na gotowy DOM,
     ale ten jeden nie.

     Przycisk jest klikalny od chwili, gdy przeglądarka go wyrysuje, a skrypt
     z atrybutem `defer` rusza dopiero po zakończeniu parsowania strony.
     W tej szczelinie — tym dłuższej, im wolniejsze łącze — kliknięcie trafiało
     w formularz bez żadnej obsługi i szło natywnym POST-em na /cart, czyli
     dokładnie tak, jak być nie miało: z przeładowaniem strony.

     Sama rejestracja nasłuchu nie dotyka treści strony (potrzebuje wyłącznie
     `document`), więc jest bezpieczna na tym etapie. */
  safely('ajaxAdd', initAjaxAdd);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ponowna inicjalizacja po edycji sekcji w edytorze motywu Shopify */
  document.addEventListener('shopify:section:load', init);
})();
